import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extra-components',
  templateUrl: './extra-components.component.html',
  styleUrls: ['./extra-components.component.scss']
})
export class ExtraComponentsComponent {

  constructor() { }

    validatePhoneNumber(number) {
        const validFormat = /^\d{10}$/;
        return number.match(validFormat);
    }

    validateEmail(email) {
        const validEmailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return email.match(validEmailFormat);
    }

}
